import React from "react";
import { usePermitted } from "../common/components/permissions/permissions";
import UnauthorizedPage from "../App/pages/Unauthorized";
import OrderReleaseLimitManager from "../admin/trading/orderReleaseLimits/orderReleaseLimitManager";

const OrderReleaseLimitPage = () => {
  const canAdministerAllLimits = usePermitted([
    "administrator",
    "operator",
    "api-query-order-release-limits",
    "api-manage-order-release-limits",
  ]);
  const canManageOrderReleaseLimits = usePermitted([
    "administrator",
    "operator",
    "api-manage-order-release-limits",
    "api-manage-own-order-release-limits",
  ]);

  if (!canManageOrderReleaseLimits) {
    return <UnauthorizedPage />;
  }

  return (
    <OrderReleaseLimitManager
      delegated={!canAdministerAllLimits}
      allowEdit={canManageOrderReleaseLimits}
      restrictToAssociatedOrganizations={!canAdministerAllLimits}
    />
  );
};

export default OrderReleaseLimitPage;